import type { AiRepairValidation } from './types';

export const parseValidationResponse = (
  content: string
): AiRepairValidation => {
  try {
    const parsed = JSON.parse(content) as {
      status?: string;
      summary?: string;
      findings?: unknown;
    };

    return {
      status: parsed.status === 'verified' ? 'verified' : 'rejected',
      summary:
        typeof parsed.summary === 'string' && parsed.summary.trim()
          ? parsed.summary.trim()
          : 'Validazione AI completata.',
      findings: Array.isArray(parsed.findings)
        ? parsed.findings.map(item => String(item)).filter(Boolean)
        : [],
    };
  } catch {
    return {
      status: 'rejected',
      summary: 'Risposta validazione OpenAI non parsabile.',
      findings: [content.slice(0, 500)],
    };
  }
};
